/**
 * @generated SignedSource<<94421db4cb13677b2a9a7e348e2a4536>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CaseAnnouncedType = "BoligPortal" | "Boligsiden" | "BoligsidenPreview" | "BorsenEjendomslink" | "Landbrugsavisen" | "Landbrugsmarkedet" | "LokaleBasen" | "Offmarket" | "Oline" | "Respace" | "Website";
import { FragmentRefs } from "relay-runtime";
export type matchHeroContentFragment_baseCase$data = {
  readonly __typename: "SalesCase";
  readonly caseAnnounced: ReadonlyArray<{
    readonly linkUrl: string | null | undefined;
    readonly type: CaseAnnouncedType;
  } | null | undefined> | null | undefined;
  readonly caseDescription?: string | null | undefined;
  readonly caseDescriptionHeading?: string | null | undefined;
  readonly id: string;
  readonly noAdvertisement?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"matchHeroDetailsFragment">;
  readonly " $fragmentType": "matchHeroContentFragment_baseCase";
};
export type matchHeroContentFragment_baseCase$key = {
  readonly " $data"?: matchHeroContentFragment_baseCase$data;
  readonly " $fragmentSpreads": FragmentRefs<"matchHeroContentFragment_baseCase">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "matchHeroContentFragment_baseCase",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CaseAnnounced",
      "kind": "LinkedField",
      "name": "caseAnnounced",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "matchHeroDetailsFragment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noAdvertisement",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "caseDescription",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "caseDescriptionHeading",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "type": "SalesCase",
      "abstractKey": null
    }
  ],
  "type": "BaseCase",
  "abstractKey": "__isBaseCase"
};

(node as any).hash = "d869ed0c28e039c737251421b6a9ae8d";

export default node;
